@if(currentView === views.Home) {
  <div class="container">
    <button (click)="getApps(true, false)" class="request-button">Ver Aplicaciones</button>

    <button (click)="selectView(views.CreatingApp)" class="request-button">Crear Aplicación</button>
  </div>

  <div class="container">
    <button (click)="selectView(views.AppsByKey)" class="request-button">Buscar aplicaciones por clave de IPs</button>

    <button (click)="selectView(views.AppsByID)" class="request-button">Buscar aplicaciones por IP</button>
  </div>

  <!-- <div class="apps-searched-container">
    <div class="app-search-information">
      <p class="text-info">Devuelve una Aplicación específica (GET).</p>
      <button (click)="searchApp()">Buscar Aplicación</button>
      <div class="name-input-container">
        <input type="text" [(ngModel)]="appNameToSearch" class="name-input" placeholder="Nombre">
        @if(appNotFound) {
          <p class="app-not-found">Aplicación no encontrada</p>
        }
      </div>
    </div>

    <div class="app-searched">
      @if(!!appSearched) {
        <p><strong>Id: </strong>{{appSearched.id}}</p>

        @if(!!appSearched.url) {
          <p><strong>Url: </strong>{{appSearched.url}}</p>
        }
      }
    </div>
  </div> -->
}

@if(currentView === views.Apps) {
  <div class="search-container">
    <input type="text" class="search-input" [(ngModel)]="appToSearch" (ngModelChange)="onSearchChange()" placeholder="Buscar por nombre">
    <button class="back-button button button-colors" (click)="selectView(views.Home)">Volver</button>
  </div>

  <!-- Vista de Aplicaciones -->
  <div class="scroll-container">
    @for(app of apps; track app.id) {
      <div class="app" (click)="selectView(views.AppDetails, app)">
        <div class="app-info-container">
          <div class="column">
            <p>{{app.id}}</p>
          </div>

          <div class="column">
            <p>{{app.url ? app.url : '- -'}}</p>
          </div>
        </div>
      </div>
    }
  </div>
}

<!-- Vista de búsqueda de Aplicación por key o Id -->
@if(currentView === views.AppsByKey || currentView === views.AppsByID) {
  <div class="search-app-container">
    <h4>Buscador de aplicaciones por {{currentView === views.AppsByKey ? 'Clave IP' : 'IP'}}</h4>

    <input type="text" class="search-input" [(ngModel)]="ipKeyOrIp" [placeholder]="currentView === views.AppsByKey ? 'Clave IP' : 'IP'">

    <div class="edit-buttons">
      <button class="button button-colors" (click)="selectView(views.Home)">Volver</button>

      <button class="button button-colors" (click)="currentView === views.AppsByKey ? getAppsFromIpsKey() : getAppsFromIP(false)" [disabled]="!ipKeyOrIp || ipKeyOrIp.length <= 0">
        Ver Aplicaciones
      </button>
    </div>
  </div>
}

<!-- Vista de detalle, editar o crear Aplicación -->
@if(currentView === views.AppDetails || currentView === views.CreatingApp || currentView === views.EditingApp) {
  @if(!!newApp) {
    <div class="edit-app-container">
      <h4>{{currentView === views.AppDetails ? 'Detalles Aplicación' : (currentView === views.CreatingApp ? 'Crear Aplicación' : 'Editando Aplicación con id "' + (appSelected?.id ?? '') + '"')}}</h4>

      <div class="input-container">
        <p class="name-info">Id: </p>
        <input type="text" class="new-input" [(ngModel)]="newApp.id" placeholder="Id" [readonly]="isReadOnly && currentView !== views.CreatingApp">
      </div>

      <div class="input-container">
        <p class="name-info">Url: </p>
        <input type="text" class="new-input" [(ngModel)]="newApp.url" placeholder="Url" [readonly]="isReadOnly && currentView !== views.CreatingApp">
      </div>

      <div class="input-container">
        <p class="name-info">Contraseña: </p>
        <div class="password-container">
          @if(currentView !== views.CreatingApp) {
            <label class="password-label">{{newApp.password ? (showPassword ? newApp.password : '****' ) : ''}}</label>

            @if(!!newApp.password) {
              <button class="show-password-button button-colors" (click)="changeShowPassword()">{{(showPassword ? 'Ocultar' : 'Mostrar')}}</button>

              <button class="show-password-button button-colors" (click)="copyToClipboard(newApp.password)">Copiar</button>
            }

            @if(currentView === views.EditingApp) {
              <button  class="show-password-button button-colors" (click)="rotatePassword()">Editar contraseña</button>
            }
          } @else {
            <input type="text" class="password-input" [(ngModel)]="newApp.password" placeholder="Password">
          }
        </div>
      </div>

      @if(currentView !== views.CreatingApp) {
        <div class="only-text-container">
          <p class="name-info">Fecha de contraseña: </p>
          <label class="date-label">{{newApp.fechaPassword | date:'dd/MM/yyyy HH:mm:ss'}}</label>
        </div>

        <div class="only-text-container">
          <p class="name-info">Antigua contraseña: </p>
          <div class="password-container">
            <label class="password-label">{{newApp.passwordOld ? (showOldPassword ? newApp.passwordOld : '****' ) : ''}}</label>

            @if(!!newApp.passwordOld) {
              <button class="show-password-button button-colors" (click)="changeShowOldPassword()">{{(showOldPassword ? 'Ocultar' : 'Mostrar')}}</button>

              <button class="show-password-button button-colors" (click)="copyToClipboard(newApp.passwordOld)">Copiar</button>

              @if(currentView === views.EditingApp) {
                <button class="show-password-button button-colors" (click)="revokeOldPassword()">Revocar contraseña</button>
              }
            }
          </div>
        </div>

        <div class="only-text-container">
          <p class="name-info">IP Keys: </p>
          <div class="ipKeys-container">
            @if(!!newApp.ipKeys && newApp.ipKeys.length > 0) {
              <div class="ipKeys-div" [ngClass]="{'all-space': currentView === views.EditingApp}">
                @for(ipKey of newApp.ipKeys; track ipKey) {
                  <button (click)="deleteIPKey(ipKey)">{{ipKey}}</button>
                }
              </div>
            }

            @if(currentView === views.AppDetails) {
              <button class="show-IPs-button button-colors" (click)="showIPs()">Ver IPs</button>
            }
          </div>
        </div>
      }

      @if(currentView === views.EditingApp) {
        <p class="info-edit-ipKeys">Para editar claves de IP no es necesario confirmar, se actualizan al instante.</p>

        <div class="edit-ipKeys-container">
          <div class="ipKeySearchToAdd-ipKey">
            <input type="text" class="add-ipKey" [(ngModel)]="ipKeySearchToAdd" (ngModelChange)="onSearchIpKeysChange()" placeholder="Filtrar lista a añadir por nombre">
          </div>

          <div class="add-ipKey-container">
            <select [(ngModel)]="ipKeyToAdd" name="add-ipKey" class="add-ipKey">
              @for(ipKey of ipKeysToAdd; track ipKey) {
                <option [value]="ipKey">{{ipKey}}</option>
              }
            </select>

            <button (click)="addIPKey()" class="add-ipKey-buton button-colors">Añadir</button>
          </div>
        </div>
      }

      <div class="input-container">
        <p class="name-info">Modo de comprobación de IP: </p>

        <div class="ipCheckmode-container">
          <select [(ngModel)]="newApp.ipCheckMode" name="ipCheckMode" class="new-input" 
            [disabled]="currentView !== views.CreatingApp && currentView !== views.EditingApp">
            <option value="Disabled">Deshabilitado</option>
            <option value="DisabledWithLog">Deshabilitado con logs</option>
            <option value="Enabled">Habilitado</option>
            <option value="EnabledWithLog">Habilitado con logs</option>
          </select>

          @if(currentView === views.AppDetails) {
            <button class="ipCheckmode-button button-colors" (click)="getIPsLog()">Ver log de IPs</button>
          } @else if(currentView === views.EditingApp) {
            <button class="ipCheckmode-button button-colors" (click)="deleteIPsLog()">Eliminar log de IPs</button>
          }
        </div>
      </div>

      @if(currentView !== views.CreatingApp) {
        <div class="only-text-container">
          <p class="name-info">Configuraciones: </p>
          <div class="configurations-container">
            @if(!!newApp.configuraciones) {
              @for(configuracion of getConfigurations(newApp.configuraciones); track configuracion.key) {
                <button (click)="showVarDetails(configuracion, typeCof)" class="pill-button">{{configuracion.key}}</button>
              }
            }

            @if(currentView === views.EditingApp && confSecretsOtherView) {
              <button (click)="selectSecondaryViews(secondaryViews.AddConfiguration)" class="add-conf-secret-button">+</button>
            }
          </div>
        </div>
      }

      @if(currentView === views.EditingApp && !confSecretsOtherView) {
        <p class="info-edit-configurations">Para editar configuraciones no es necesario confirmar, se actualizan al instante.</p>

        <div class="edit-configurations-container">
          <div class="configuration-var-name-container">
            <input type="text" [(ngModel)]="nameCfgToAdd" placeholder="Nombre de configuración">
          </div>

          @if(!confSecretsOtherView) {
            <div class="configuration-var-value-container">
              <textarea type="text" [(ngModel)]="valueCfgToAdd" class="configuration-textarea" placeholder="Valor de configuración"></textarea>

              <button (click)="addConfiguration()" class="button-colors" [disabled]="(!nameCfgToAdd || nameCfgToAdd === ' ') || (!valueCfgToAdd || valueCfgToAdd === ' ')">
                Añadir
              </button>
            </div>
          }
        </div>

        <div class="edit-configurations-container">
          <div class="configuration-var-name-container">
            <select [(ngModel)]="nameCfgToModify" name="add-ipKey">
              @for(configuration of configurationsNames; track configuration) {
                <option [value]="configuration">{{configuration}}</option>
              }
            </select>
          </div>

          <div class="configuration-var-value-container">
            <textarea type="text" [(ngModel)]="valueCfgToModify" class="configuration-textarea" placeholder="Valor de configuración"></textarea>

            <button (click)="deleteConfiguration()" class="button-colors" [disabled]="configurationsNames && configurationsNames.length === 0">Eliminar</button>

            <button (click)="editConfiguration()" class="edit-configuration-button button-colors"
              [disabled]="(configurationsNames && configurationsNames.length === 0) || !valueCfgToModify || valueCfgToModify.length === 0 || valueCfgToModify === ' '">
              Editar
            </button>
          </div>
        </div>
      }

      @if(currentView !== views.CreatingApp) {
        <div class="only-text-container">
          <p class="name-info">Secretos: </p>
          <div class="secrets-container">
            @if(!!newApp.secretos) {
              @for(secret of getSecrets(newApp.secretos); track secret.key) {
                <button (click)="showVarDetails(secret, typeSecret)"  class="pill-button">
                  {{secret.key}}
                </button>
              }
            }

            @if(currentView === views.EditingApp && confSecretsOtherView) {
              <button (click)="selectSecondaryViews(secondaryViews.AddSecret)" class="add-conf-secret-button">+</button>
            }
          </div>
        </div>
      }

      @if(currentView === views.EditingApp && !confSecretsOtherView) {
        <p class="info-edit-secrets">Para editar secretos no es necesario confirmar, se actualizan al instante.</p>

        <div class="edit-secrets-container">
          <div class="secret-var-name-container">
            <input type="text" [(ngModel)]="nameSecretToAdd" placeholder="Nombre de secreto">
          </div>

          <div class="secret-var-value-container">
            <input type="text" [(ngModel)]="valueSecretToAdd" placeholder="Valor de secreto">

            <button (click)="addSecret()" class="button-colors" [disabled]="(!nameSecretToAdd || nameSecretToAdd === ' ') || (!valueSecretToAdd || valueSecretToAdd === ' ')">
              Añadir
            </button>
          </div>
        </div>

        <div class="edit-secrets-container">
          <div class="secret-var-name-container">
            <select [(ngModel)]="nameSecretToModify" name="add-ipKey">
              @for(secret of secretsNames; track secret) {
                <option [value]="secret">{{secret}}</option>
              }
            </select>
          </div>

          <div class="secret-var-value-container">
            <input type="text" [(ngModel)]="valueSecretToModify" placeholder="Valor de secreto" class="edit-secret-input">

            <button (click)="deleteSecret()" class="button-colors" [disabled]="secretsNames && secretsNames.length === 0">Eliminar</button>

            <button (click)="editSecret()" class="edit-secret-button button-colors"
              [disabled]="(secretsNames && secretsNames.length === 0) || !valueSecretToModify || valueSecretToModify.length === 0 || valueSecretToModify === ' '">
              Editar
            </button>
          </div>
        </div>
      }

      <div class="edit-buttons">
        <button class="button button-colors" (click)="currentView === views.AppDetails ? selectView(views.Apps) : (currentView === views.CreatingApp ? selectView(views.Home) : selectView(views.AppDetails))">
          Volver
        </button>

        @if(currentView === views.AppDetails) {
          <button class="button button-colors" (click)="deleteApp()" [disabled]="!globalService.editing">Eliminar Aplicación</button>
        }

        <button class="button button-colors" (click)="currentView === views.AppDetails ? selectView(views.EditingApp) : (currentView === views.CreatingApp ? createApp() : editApp())"
          [disabled]="!globalService.editing || newApp.id.length === 0 || newApp.id.trim() === ''">
          {{currentView === views.AppDetails ? 'Editar' : 'Confirmar'}}
        </button>
      </div>
    </div>
  }
}

<!-- Vista de listado IPs de log -->
@if(currentView === secondaryViews.IPsLog) {
  <div class="log-ips-list-container">
    @if(!!ipsLog) {
      @if(ipsLog.authorized.length > 0) {
        <div class="ips-list-container">
          <p class="ips-list-title" (click)="ipsLogOpen !== ipsLogTypesEnum.Authorized ? selectedLogIP = '' : null; ipsLogOpen = ipsLogTypesEnum.Authorized"
            [ngClass]="{'selected-ipsLogOpen': ipsLogOpen === ipsLogTypesEnum.Authorized}">
            Autorizadas ({{ipsLog.authorized.length}})
          </p>

          @if(ipsLogOpen === ipsLogTypesEnum.Authorized) {
            @for(ip of ipsLog.authorized; track ip) {
              <p class="ips-list-element" [ngClass]="{'selected-ip': selectedLogIP === ip}" (click)="selectedLogIP === ip ? selectedLogIP = '' : selectedLogIP = ip">{{ip}}</p>
            }
          }
        </div>
      }

      @if(ipsLog.unauthorized.length > 0) {
        <div class="ips-list-container">
          <p class="ips-list-title" (click)="ipsLogOpen !== ipsLogTypesEnum.Unauthorized ? selectedLogIP = '' : null; ipsLogOpen = ipsLogTypesEnum.Unauthorized"
            [ngClass]="{'selected-ipsLogOpen': ipsLogOpen === ipsLogTypesEnum.Unauthorized}">
            No autorizadas ({{ipsLog.unauthorized.length}})
          </p>

          @if(ipsLogOpen === ipsLogTypesEnum.Unauthorized) {
            @for(ip of ipsLog.unauthorized; track ip) {
              <p class="ips-list-element" [ngClass]="{'selected-ip': selectedLogIP === ip}" (click)="selectedLogIP === ip ? selectedLogIP = '' : selectedLogIP = ip">{{ip}}</p>
            }
          }
        </div>
      }

      @if(ipsLog.unused.length > 0) {
        <div class="ips-list-container">
          <p class="ips-list-title" (click)="ipsLogOpen !== ipsLogTypesEnum.Unused ? selectedLogIP = '' : null; ipsLogOpen = ipsLogTypesEnum.Unused"
            [ngClass]="{'selected-ipsLogOpen': ipsLogOpen === ipsLogTypesEnum.Unused}">
            Sin uso ({{ipsLog.unused.length}})
          </p>

          @if(ipsLogOpen === ipsLogTypesEnum.Unused) {
            @for(ip of ipsLog.unused; track ip) {
              <p class="ips-list-element" (click)="selectedLogIP === ip ? selectedLogIP = '' : selectedLogIP = ip" [ngClass]="{'selected-ip': selectedLogIP === ip}">{{ip}}</p>
            }
          }
        </div>
      }
    }

    <div class="ips-list-buttons-container">
      <button class="ips-list-button button-colors" (click)="selectView(views.AppDetails)">Volver</button>

      <button class="ips-list-button button-colors" (click)="getKeysFromIP()" [disabled]="selectedLogIP === ''">Buscar IP Keys</button>

      <button class="ips-list-button button-colors" (click)="getAppsFromIP(true)" [disabled]="selectedLogIP === ''">Buscar aplicaciones</button>
    </div>
  </div>
}

<!-- Vista de crear y editar Configuración o Secreto -->
@if(
  currentView === secondaryViews.EditConfiguration || currentView === secondaryViews.AddConfiguration || 
  currentView === secondaryViews.EditSecret || currentView === secondaryViews.AddSecret
) {
  <div class="info-conf-secret-container">
    <h4>
      {{currentView === secondaryViews.EditConfiguration || currentView === secondaryViews.EditSecret ? 'Editar ' : 'Crear '}} 
      {{currentView === secondaryViews.AddConfiguration || currentView === secondaryViews.EditConfiguration ? 'Configuración' : 'Secreto'}}
    </h4>

    <div class="conf-secret-input-container">
      <label>Nombre:</label>
      @if(currentView === secondaryViews.EditConfiguration || currentView === secondaryViews.EditSecret) {
        <label class="conf-secret-name">{{newVariable.name}}</label>
      }
      @if(currentView === secondaryViews.AddConfiguration || currentView === secondaryViews.AddSecret) {
        <input type="text" class="conf-secret-input" [(ngModel)]="newVariable.name" [placeholder]="currentView === secondaryViews.AddConfiguration ? 'Nombre de configuración' : 'Nombre de secreto'">
      }
    </div>

    <div class="conf-secret-input-container">
      <label>Valor:</label>
      <textarea type="text" class="textarea" [(ngModel)]="newVariable.value" 
        [placeholder]="currentView === secondaryViews.EditConfiguration || currentView === secondaryViews.AddConfiguration ? 'Valor de configuración' : 'Valor de secreto'">
      </textarea>
    </div>

    <div class="info-buttons">
      <button class="button button-colors" (click)="selectView(views.EditingApp)">Volver</button>

      @if(currentView === secondaryViews.EditConfiguration || currentView === secondaryViews.EditSecret) {
        <button class="button button-colors"  [disabled]="!globalService.editing"
          (click)="currentView === secondaryViews.EditConfiguration ? deleteConfiguration() : (currentView === secondaryViews.EditSecret ? deleteSecret() : '')">
          Eliminar
        </button>
      }

      <button class="button button-colors" [disabled]="!globalService.editing || (!newVariable.name || newVariable.name === ' ') || (!newVariable.value || newVariable.value === ' ')"
        (click)=" currentView === secondaryViews.AddConfiguration ? addConfiguration() : 
                  (currentView === secondaryViews.EditConfiguration ? editConfiguration() : 
                    ( currentView === secondaryViews.AddSecret ? addSecret() : editSecret()))">
        Confirmar
      </button>
    </div>
  </div>
}